import type { PartyType } from "../types/esign.types.ts"

// Mirrors EnvelopeRecipient.is_countersigner in ezbuild_back, which only lets the one internal recipient sign.
export const isCountersigner = (recipient: { party_type: PartyType }) =>
  recipient.party_type === "internal"
